const { es } = require('../ES/spanishInfo')
const { en } = require('../EN/englishInfo')
const { ja } = require('../JA/japaneseInfo')

const currentLanguages = [en, es, ja]

exports.currentLanguages = currentLanguages
